import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-503ca7db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-navigation" }
const _hoisted_2 = { class: "page-navigation__list" }
const _hoisted_3 = { class: "page-navigation__list__item__link__label" }
const _hoisted_4 = { class: "page-navigation__list__item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bx bx-cog" }, null, -1))
const _hoisted_6 = { class: "page-navigation__list__item__link__label" }
const _hoisted_7 = {
  key: 0,
  class: "page-navigation__list__item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bx bx-pen" }, null, -1))
const _hoisted_9 = { class: "page-navigation__list__item__link__label" }
const _hoisted_10 = {
  key: 1,
  class: "page-navigation__list__item"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bx bx-help-circle" }, null, -1))
const _hoisted_12 = { class: "page-navigation__list__item__link__label" }

import { computed } from 'vue';
import { RouteRecordRaw, useRoute } from 'vue-router';
import RoutesOps from '@apps/ops/src/data/routes.json';
import RoutesDashboard from '@apps/dashboard/src/data/routes.json';

interface TypePageNavigation {
	url: RouteRecordRaw;
	label: string;
	icon: string;
	env?: 'ci-latest' | 'sandbox' | 'production';
}

const DOCS_URL = 'https://docs.payaut.com/docs/how/introduction/index.html';

export default /*#__PURE__*/_defineComponent({
  __name: 'PageNavigation',
  props: {
    isShowingHomepage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const Routes = process.env.VUE_APP_TYPE === 'ops' ? RoutesOps : RoutesDashboard;
const navigationRoutes = Routes.routes as Array<TypePageNavigation>;
const route = useRoute();

const IS_OPS = process.env.VUE_APP_TYPE === 'ops';

const computedRoutes = computed((): TypePageNavigation[] => {
	if (IS_OPS) {
		return navigationRoutes.filter(
			(navRoute) => !navRoute.env || navRoute.env === process.env.VUE_APP_ENV
		);
	}

	return navigationRoutes.filter(
		(currRoute: TypePageNavigation) =>
			!(!props.isShowingHomepage && currRoute.url.name === 'homepage') &&
			(!currRoute.env || currRoute.env === process.env.VUE_APP_ENV)
	);
});

function getUrl(url: Partial<RouteRecordRaw>) {
	let newUrl = url;
	let query;
	if (route.name === url.name) {
		query = { query: route.query };
		newUrl = { ...url, ...query };
	} else {
		query = IS_OPS
			? {
					query: {
						merchantCode: route.query?.merchantCode,
						divisionCode: route.query?.divisionCode,
					},
			  }
			: {};
		newUrl = { ...url, ...query };
	}
	return newUrl;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedRoutes.value, (route, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: idx,
            class: "page-navigation__list__item"
          }, [
            _createVNode(_component_router_link, {
              to: getUrl(route.url),
              title: _ctx.$t(route.label),
              class: "page-navigation__list__item__link"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(`bx bx-${route.icon}`)
                }, null, 2),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(route.label)), 1)
              ]),
              _: 2
            }, 1032, ["to", "title"])
          ]))
        }), 128))
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: getUrl({ name: 'configurations' }),
            class: "page-navigation__list__item__link"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('routes.configurations')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        (!IS_OPS)
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: getUrl({ name: 'contracts' }),
                class: "page-navigation__list__item__link"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('sidebar.contracts')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true),
        (!IS_OPS)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createElementVNode("a", {
                href: DOCS_URL,
                class: "page-navigation__list__item__link",
                target: "_blank"
              }, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('sidebar.help')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})